import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Alert } from 'reactstrap'
import { useNavigate, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import EditHeader from '../components/edit/EditHeader'
import EditInstanceForm from '../components/edit/EditInstanceForm'
import servicio from '../services/apiInstanceService'
import apiDistributorService from '../services/apiDistributorService'
import '../styles/FormView.css'

function EditView() {
  const navigate = useNavigate()
  const location = useLocation()
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    url: '',
    fiscalName: '',
    status: 'ACTIVE',
    distributorId: '',
  })

  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [distributors, setDistributors] = useState([])
  const [isLoadingDistributors, setIsLoadingDistributors] = useState(false)
  const [distributorsError, setDistributorsError] = useState('')

  useEffect(() => {
    if (location.state?.instancia) {
      const instancia = location.state.instancia
      setFormData({
        ...instancia,
        distributorId: instancia.distributorId ?? '',
      })
    } else {
      navigate(-1)
    }
  }, [location, navigate])

  useEffect(() => {
    let isMounted = true
    const loadDistributors = async () => {
      setIsLoadingDistributors(true)
      setDistributorsError('')
      try {
        const distributorData = await apiDistributorService.listDistributors(0, 1000)
        const distributorContent = Array.isArray(distributorData?.content) ? distributorData.content : []
        if (isMounted) {
          setDistributors(distributorContent)
        }
      } catch (error) {
        if (isMounted) {
          setDistributorsError('No se pudieron cargar los distribuidores.')
        }
      } finally {
        if (isMounted) {
          setIsLoadingDistributors(false)
        }
      }
    }

    loadDistributors()
    return () => {
      isMounted = false
    }
  }, [])

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

  

    if (!formData.fiscalName.trim()) {
      newErrors.fiscalName = 'El nombre fiscal es requerido'
    }

    return newErrors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setErrorMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setIsSaving(true)
    try {
      await servicio.actualizarInstancia(formData.id, {
        name: formData.name,
        fiscalName: formData.fiscalName,
        status: formData.status,
        distributorId: formData.distributorId ? Number(formData.distributorId) : null,
      })
      navigate(-1)
    } catch (error) {
      setErrorMessage('No se pudo actualizar la instancia.')
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    navigate(-1)
  }

  const handleResetAdminPassword = () => {
    console.log('Regenerar contraseÃ±a de administrador')
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <EditHeader title="Editar Instancia" />

          {errorMessage && (
            <Row className="mb-3">
              <Col md="8">
                <Alert color="danger">{errorMessage}</Alert>
              </Col>
            </Row>
          )}
          {distributorsError && (
            <Row className="mb-3">
              <Col md="8">
                <Alert color="danger">{distributorsError}</Alert>
              </Col>
            </Row>
          )}

          <Row>
            <Col md="8">
              <EditInstanceForm
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                distributors={distributors}
                isLoadingDistributors={isLoadingDistributors}
                onChange={handleInputChange}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                onResetAdminPassword={handleResetAdminPassword}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default EditView
